export default {
  userAccessFor: 'Acesso de usuário para:',
  save: 'Salvar',
  search: 'Buscar',
  name: 'Nome',
  lastname: 'Sobrenome',
  email: 'E-mail'
}
